export default "__VITE_ASSET__Cnhm8N0Y__"